var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper"},[_c('privacy-policy')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }